import { IMaintenance } from '../../../../types/maintenance.type';
import { useEffect, useState } from 'react';
import { getMaintenanceById } from '../../../../common/services/maintenance.api';
import { Modal } from 'flowbite-react';
import FormBudgetMaintenance from '../forms/FormBudgetMaintenance';
import Loading from '../../../../common/components/ui/loading/Loading';

type FormPropsCreateMaintenance = {
  data: IMaintenance
  onClose?: () => void
}

export default function ModalBudgetMaintenance(props: FormPropsCreateMaintenance) {
  const [maintenanceData, setMaintenanceData] = useState<IMaintenance>();

  useEffect(() => {
    async function loadMaintenanceData() {

      if (!props.data._id) {
        return;
      }

      const { data } = await getMaintenanceById(props.data._id);
      const { corrective, preventive, misuse } = data.budgetMaintenance;

      const processedData = {
        ...data,
        corrective,
        preventive,
        misuse
      };

      setMaintenanceData(processedData);
    }
    loadMaintenanceData();
  }, [props.data._id]);

  return (
    <Modal
      show={true}
      onClose={() => props.onClose && props.onClose()}
      size="7xl"
      className="w-full"
    >
      <div className="relative text-black dark:text-black">
        <Modal.Header>
          <section className='text-black dark:text-black'>
            <h3>
              {`Editando Peças: ${maintenanceData?.licensePlate}`}
            </h3>
            <h2>{`Mecânico responsável: ${maintenanceData?.mechanic}`}</h2>
            <h2>{`Senha: ${maintenanceData?.waitingTicket}`}</h2>
          </section>
        </Modal.Header>
        <Modal.Body className="w-full relative border-gray flex flex-col" style={{ minHeight: 'calc(100vh - 300px)', height: 'calc(100vh - 300px)' }}>
          {maintenanceData ? (
            <FormBudgetMaintenance
              onClose={props.onClose}
              data={maintenanceData}
            />
          ) : <Loading />}
        </Modal.Body>
      </div>
    </Modal>
  )
}